module.exports = __webpack_public_path__ + "static/media/searchicon.7c83c7aa.png";